/** Most API reads return {data}; /api/me returns its identity object directly. */
export function unwrapApiResponse<T>(body:unknown):T{
 if(body!==null&&typeof body==='object'&&Object.hasOwn(body,'data'))return (body as {data:T}).data;
 return body as T;
}
